// extracted by mini-css-extract-plugin
export default {"resetStyles":"EmailPreviewModal_resetStyles__GHmoG"};